module.exports = __webpack_public_path__ + "img/metamask.94915cd0.png";